import { render, staticRenderFns } from "./ModalTransfers.vue?vue&type=template&id=072a7d53&"
import script from "./ModalTransfers.vue?vue&type=script&lang=js&"
export * from "./ModalTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports